import React from "react";
import { useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Legend,
  Tooltip,
  CartesianGrid,
} from "recharts";

// const data = [
//   { name: "2018", amt: 2400 },
//   { name: "2019", amt: 2210 },
//   { name: "2020", amt: 2290 },
//   { name: "2021", amt: 2000 },
//   { name: "2022", amt: 2181 },
//   { name: "2023", amt: 2500 },
//   { name: "2024", amt: 2100 },
// ];

const BiomasGraph = () => {
  const url = "api/v2/dashboard/getAllDashboardData";
 
  const data = useSelector((state) => state.fetch.data[url] || []);



  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white   w-full h-[25rem]">
      <span className="text-[#424242] text-[.75rem] font-[500] font-interSans">
        Land Reclamation
      </span>
      <div className="w-full h-full mt-[2rem]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart width={150} height={40} data={data?.landReclamation} margin={{ bottom: 60 }}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="name" tickLine={false} />
            <YAxis axisLine={false} tickLine={false} />
            <Tooltip
             cursor={{ fill: "transparent" }}
              contentStyle={{ fontSize: "0.75rem", borderRadius: 8 }}
            />
            <Legend />
            <Bar dataKey="amt" fill="#009957" barSize={50} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BiomasGraph;
